document.addEventListener('DOMContentLoaded', function() {
  const questions = document.querySelectorAll('.faq-question');
  const searchInput = document.getElementById('faqSearch');
  const suggestionsBox = document.getElementById('faqSuggestions');
  const expandAll = document.getElementById('faqExpandAll');
  const collapseAll = document.getElementById('faqCollapseAll');

  // 1. Функция открытия/закрытия
  function toggleItem(btn) {
    const isExpanded = btn.getAttribute('aria-expanded') === 'true';
    const answer = btn.nextElementSibling;
    btn.setAttribute('aria-expanded', !isExpanded);
    if (answer) {
      answer.style.display = isExpanded ? 'none' : 'block';
    }
  }

  questions.forEach(q => {
    q.onclick = function(e) {
      e.preventDefault();
      toggleItem(this);
    };
  });

  // 2. Кнопки Показать/Скрыть всё
  expandAll.onclick = () => {
    questions.forEach(q => {
      q.setAttribute('aria-expanded', 'true');
      if (q.nextElementSibling) q.nextElementSibling.style.display = 'block';
    });
  };

  collapseAll.onclick = () => {
    questions.forEach(q => {
      q.setAttribute('aria-expanded', 'false');
      if (q.nextElementSibling) q.nextElementSibling.style.display = 'none';
    });
  };

  // 3. Поиск с подсказками
  searchInput.oninput = function() {
    const query = this.value.toLowerCase().trim();
    suggestionsBox.innerHTML = '';
    
    if (query.length < 2) {
      suggestionsBox.hidden = true;
      resetSearch();
      return;
    }

    let matches = [];
    document.querySelectorAll('.faq-item').forEach(item => {
      const qText = item.querySelector('.faq-question').textContent;
      const aText = item.querySelector('.faq-answer-content').textContent;
      
      if (qText.toLowerCase().includes(query) || aText.toLowerCase().includes(query)) {
        item.style.display = 'block';
        matches.push({ element: item, question: qText });
      } else {
        item.style.display = 'none';
      }
    });

    if (matches.length > 0) {
      suggestionsBox.hidden = false;
      matches.slice(0, 5).forEach(match => {
        const div = document.createElement('div');
        div.className = 'faq-suggestion-item';
        div.textContent = match.question;
        div.onclick = () => {
          searchInput.value = '';
          suggestionsBox.hidden = true;
          resetSearch();
          const btn = match.element.querySelector('.faq-question');
          btn.setAttribute('aria-expanded', 'true');
          btn.nextElementSibling.style.display = 'block';
          match.element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        };
        suggestionsBox.appendChild(div);
      });
    } else {
      suggestionsBox.hidden = true;
    }

    updateCategories();
  };

  function resetSearch() {
    document.querySelectorAll('.faq-item').forEach(i => i.style.display = 'block');
    updateCategories();
  }

  function updateCategories() {
    document.querySelectorAll('.faq-category').forEach(cat => {
      const hasVisible = Array.from(cat.querySelectorAll('.faq-item')).some(i => i.style.display !== 'none');
      cat.style.display = hasVisible ? 'block' : 'none';
    });
  }
});
